import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { H5, P } from '../../../AbstractElements'; // İsteğe bağlı olarak AbstractElements kullanılabilir

const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  } catch (error) {
    console.error("Error formatting date:", dateString, error);
    return '';
  }
};

const AnnouncementDetailModal = ({ isOpen, toggle, announcement }) => {
  if (!announcement) {
    return null;
  }

  const formattedDate = formatDate(announcement.created);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} className="d-flex justify-content-between align-items-start">
        {formattedDate && (
          <span className="text-muted small">{formattedDate}</span>
        )}
      </ModalHeader>
      <ModalBody>
        <H5 className="modal-title me-auto">{announcement.title}</H5>

        <P style={{ whiteSpace: 'pre-wrap' }}>
          {announcement.desc}
        </P>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Kapat
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AnnouncementDetailModal; 